import styled from 'styled-components';
import {isGloboCurrentApp, AudioCardBackgroundImagegByCurrentApp} from '../../../../utils/get-app-env'

export const CardRoot = styled.div<{ $isFocused: boolean }>`
  ${(isGloboCurrentApp() ? 
    'border: 1px solid #948f8f;' + 
    'border-radius: 4px;' 
    : 
    'border: 1px solid #B1B1B1;' +
    'border-radius: 8px;'
  )}

  cursor: pointer;
  transition: all 0.2s linear;
  background-image: ${props => props.$isFocused && AudioCardBackgroundImagegByCurrentApp()};
  

  * {
    fill: ${props => props.$isFocused && '#fff'};
    color: ${props => props.$isFocused && '#fff'};
  }

  p {
    color: ${props => props.$isFocused && '#fff'};
  }

  hr {
    background-color: ${props => props.$isFocused && '#fff'};
  }

  :hover {
    background-image: ${(AudioCardBackgroundImagegByCurrentApp())};
    

    p {
      color: ${props => props.$isFocused && '#fff'};
    }

    * {
      color: #fff;
      fill: #fff;
    }
    
    hr {
      background-color: #fff;
    }
  }

  
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5;
  padding: 2px;

  > div {
    padding: 5px 10px;
  }

`;